import { useGetList } from "ra-core";
import { useMemo } from "react";

import type { ContactSource } from "../types";

/** Sources already used by contacts, the most used first. */
export const useSourcesByUsage = () => {
  const { data = [] } = useGetList<ContactSource>("contact_sources", {
    pagination: { page: 1, perPage: 1000 },
    sort: { field: "name", order: "ASC" },
  });
  return useMemo(
    () =>
      [...data].sort(
        (a, b) => b.nb_contacts - a.nb_contacts || a.name.localeCompare(b.name),
      ),
    [data],
  );
};
